import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
function Contact() {
  const initialFormData = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    position: "",
    companyName: "",
    message: "",
  };
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  // const Sitekey = "6Lfv-DMqAAAAANtvMg94G_hI_E7FfPttI31DqknS";
  // const secretkey='6Lfv-DMqAAAAAG9uye5-azG2Jo43D9Bsch0fU_3m';
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const captchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phoneNumber: value });
  };

  const handleCaptcha = (value) => {
    setCaptchaVerified(!!value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaVerified) {
      toast.error("Please verify that you are not a robot.",{
        autoClose: 1000,
      });
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/sendemail`,
        {
          from_email: formData.email,
          f_name: formData.firstName,
          l_name: formData.lastName,
          phoneno: formData.phoneNumber,
          position: formData.position,
          company: formData.companyName,
          body: formData.message,
        }
      );

      toast.success("Your message has been sent successfully!", {
        autoClose: 1000,
        onClose: () => navigate("/"),
      });
     
      captchaRef.current.reset();
      setCaptchaVerified(false);
      setFormData(initialFormData);
    } catch (error) {
      toast.error("Failed to send Message");
    }
  };
  console.log("ReCAPTCHA Site Key:", process.env.REACT_APP_SITE_KEY);
  return (
    <>
      {" "}
      <ToastContainer />
      <div
        className="contactpage_section wow animate__fadeInUp"
        data-wow-duration="1s"
      >
        <div className="contactpage_container">
          <div className="contactpage_wrapper">
            <div className="contactpage_content_con">
              <h1 className="portfoliotitle" style={{ fontSize: "60px" }}>
                Get In Touch
              </h1>
              <p>
                Contact us anytime with an idea or send us your requirements and
                we'll love to add value to it.
              </p>
              <div className="contactpage_likns_grid">
                <a className="contact_link" href="tel:+12026008034">
                  <img
                    src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb61821c20a67_icon-1-contact-links-dark-template.svg"
                    className="image_contact_link_icon"
                    alt=""
                  />
                  <div className="contacttext">+1 (202) 600-8034</div>
                </a>
                <a
                  className="contact_link"
                  href="mailto:info@netaesthetics.com"
                >
                  <img
                    src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61962f94f13cb6d14dc20a6b_icon-2-contact-links-dark-template.svg"
                    className="image_contact_link_icon"
                    alt=""
                  />
                  <div className="contacttext">info@netaesthetics.com</div>
                </a>
              </div>
              <div className="contact_social_media">
                <h3 className="followustitle">Follow Us</h3>
                <div class="contact_social_media_links">
                  <a
                    class="social_media_link"
                    target="_blank"
                    href="https://www.facebook.com/NetAesthetics/"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11507f77e9ffbee3b49d3_NetAetshetics%20Social%20Icon%20-%20Facebook.svg"
                      alt=""
                    />
                  </a>
                  <a
                    class="social_media_link"
                    target="_blank"
                    href="https://www.instagram.com/netaesthetics/"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d1150862b7fa02c26b07b0_NetAetshetics%20Social%20Icon%20-%20Instagram.svg"
                      alt=""
                    />
                  </a>
                  <a
                    class="social_media_link"
                    target="_blank"
                    href="https://www.linkedin.com/company/netaesthetics/"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d115079c5e182becc9024a_NetAetshetics%20Social%20Icon%20-%20LinkedIn.svg"
                      alt=""
                    />
                  </a>
                  <a
                    class="social_media_link"
                    target="_blank"
                    href="https://www.upwork.com/ag/netaesthetics/"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11508550a566ce87de603_NetAetshetics%20Social%20Icon%20-%20UpWork.svg"
                      alt=""
                    />
                  </a>
                  <a
                    class="social_media_link"
                    target="_blank"
                    href="https://www.crunchbase.com/organization/netaesthetics"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11507b378db2d3e116613_NetAetshetics%20Social%20Icon%20-%20Crunchbase.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="contactpage_contactform">
              <div className="card-contact-form-gradient-blur"></div>
              <div className="contactform">
                <form onSubmit={handleSubmit}>
                  <div className="form-group flex-group">
                    <div className="flex-group1">
                      <label htmlFor="firstName">First Name *</label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder="Ex. John"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="flex-group1">
                      <label htmlFor="lastName">Last Name *</label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder="Ex. Smith"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group flex-group">
                    <div className="flex-group1">
                      <label htmlFor="email">Email *</label>
                      <input
                        type="email"
                        id="email"
                        placeholder="Ex. johnsmith@gmail.com"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="flex-group1">
                      <label htmlFor="phoneNumber">Phone Number *</label>
                      <PhoneInput
                        placeholder="Enter phone number"
                        className="PhoneInput"
                        value={formData.phoneNumber}
                        onChange={handlePhoneChange}
                        defaultCountry="PK"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group flex-group">
                    <div className="flex-group1">
                      <label htmlFor="position">Position *</label>
                      <input
                        type="text"
                        id="position"
                        name="position"
                        placeholder="Ex. Chief Technical Officer"
                        value={formData.position}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="flex-group1">
                      <label htmlFor="companyName">Company Name *</label>
                      <input
                        type="text"
                        id="companyName"
                        name="companyName"
                        placeholder="Ex. NetAesthetics"
                        value={formData.companyName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Additional Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      placeholder="Please enter your message."
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="recaptcha-container ">
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_SITE_KEY}
                      onChange={handleCaptcha}
                      ref={captchaRef}
                      className="captcha"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <button type="submit" className="submit-button">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
